// load scss
import './Main.scss';

// load svg sprite
import loadSpriteSvgs from './Component/Sprite/LoadSprite';
loadSpriteSvgs();

import './Component/PhotoSwipe/PhotoSwipe.js';
import './Component/Menu';
import './Component/Header/Header';
import './Component/HeaderVideo/HeaderVideo';
import './Component/ReadMore';
import './Content/Video/Video.js';
import './Component/ScrollToTopButton/ScrollToTopButton';

function handleClickableElements() {
    const elements = document.querySelectorAll('.--clickable-element');
    elements.forEach(el => {
        el.addEventListener('click', (event) => {
            const link = event.currentTarget.querySelector('a.link');
            if (link) {
                link.click();
            }
        });
    });
}

handleClickableElements();
